import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ArticleHeading4, UIText2 } from '@cian/ui-kit';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { EAnchorBlock } from '../../../../repositories/price-estimator/entities/onboardings/TooltipSchema';
import { Section } from '../../../packages/Section';

import * as styles from './styles.css';

interface IEntryTexts {
  mainText: string;
  secondaryText?: string;
}

export interface IEntryBannerProps {
  onView(): void;
  onClick(): void;
  entryTexts: IEntryTexts;
}

export const EntryBanner: React.FC<IEntryBannerProps> = ({ entryTexts, onClick, onView }) => {
  return (
    <ActionAfterViewObserver callback={onView} callbackDelay={1500}>
      <Section>
        <div
          id={EAnchorBlock.OffersHistory}
          className={styles['container']}
          onClick={onClick}
          data-testid="offers_history_entry_banner"
        >
          <div className={styles['house']} />
          <div className={styles['text']}>
            <ArticleHeading4>{entryTexts.mainText}</ArticleHeading4>
            {entryTexts.secondaryText && <UIText2>{entryTexts.secondaryText}</UIText2>}
          </div>
          <div className={styles['arrow']}>
            <IconActionChevronRight16 color="icon-secondary-default" display="block" />
          </div>
        </div>
      </Section>
    </ActionAfterViewObserver>
  );
};
